import React from "react";
import Typography from "@material-ui/core/Typography";

const H4 = (props: any) => (
  <Typography variant="h4" component="h4" gutterBottom {...props} />
);

export default H4;
